import React from 'react';
import { LawFirmContextType } from './lawFirm.types';
import { UserContextType } from '../../user/user.types';
import { Lawyer } from '../../entity/entity.types';
import { fetchLawFirmLawyers } from './lawFirm.api';
import { LawFirmHeader } from './header/LawFirmHeader';
import { LawFirmTopDecisions } from './decisions/LawFirmTopDecisions';
import { LawFirmLawyers } from './lawyers/LawFirmLawyers';
import { LawFirmDescription } from './description/LawFirmDescription';
import { LawFirmCases } from './cases/LawFirmCases';
import { LawFirmClients } from './clients/LawFirmClients';
import { withLawFirm } from './LawFirmContext';
import { withUser } from '../../user/UserContext';
import { rebuildUrlWithoutSource } from '../../utils/url-utils/urlUtils';

type Props = UserContextType & LawFirmContextType;

type State = {
  lawyers: Array<Lawyer>;
};

export class RawLawFirmMain extends React.Component<Props, State> {
  state: State = {
    lawyers: [],
  };

  async componentDidMount() {
    const {
      lawFirmInfos: { lawOfficeId },
    } = this.props;
    const { lawyers } = await fetchLawFirmLawyers(lawOfficeId);
    this.setState({ lawyers });
    rebuildUrlWithoutSource();
  }

  render() {
    const {
      experience: { domains, juridictions, villes },
    } = this.props;
    const { lawyers } = this.state;
    const nbLawyers = lawyers ? lawyers.length : 0;
    const hasExperience =
      domains.length > 0 || juridictions.length > 0 || villes.length > 0;
    return (
      <>
        <LawFirmHeader nbLawyers={nbLawyers} />
        <LawFirmTopDecisions />
        {nbLawyers > 0 && <LawFirmLawyers lawyers={lawyers} />}
        <LawFirmDescription hasExperience={hasExperience} />
        {hasExperience && <LawFirmCases />}
        <LawFirmClients />
      </>
    );
  }
}

export const LawFirmMain = withLawFirm(withUser(RawLawFirmMain));
